import {
  File, FileText, Image as ImageIcon, FileSpreadsheet, FileArchive,
  FileVideo, FileAudio, FileCode, Folder, Building2, LayoutTemplate, Kanban,
} from "lucide-react";

export function formatBytes(bytes) {
  const b = Number(bytes) || 0;
  if (b < 1024) return `${b} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let val = b / 1024;
  let i = 0;
  while (val >= 1024 && i < units.length - 1) {
    val /= 1024;
    i += 1;
  }
  return `${val.toFixed(val >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
}

const EXT_MAP = {
  pdf: FileText, txt: FileText, md: FileText, doc: FileText, docx: FileText, rtf: FileText,
  png: ImageIcon, jpg: ImageIcon, jpeg: ImageIcon, gif: ImageIcon, webp: ImageIcon, svg: ImageIcon, heic: ImageIcon,
  xls: FileSpreadsheet, xlsx: FileSpreadsheet, csv: FileSpreadsheet, numbers: FileSpreadsheet,
  zip: FileArchive, rar: FileArchive, "7z": FileArchive, tar: FileArchive, gz: FileArchive,
  mp4: FileVideo, mov: FileVideo, avi: FileVideo, webm: FileVideo,
  mp3: FileAudio, wav: FileAudio, ogg: FileAudio, flac: FileAudio,
  js: FileCode, ts: FileCode, json: FileCode, html: FileCode, css: FileCode, py: FileCode,
};

export function fileIcon(filename = "", contentType = "") {
  const ext = (filename.split(".").pop() || "").toLowerCase();
  if (EXT_MAP[ext]) return EXT_MAP[ext];
  if (contentType.startsWith("image/")) return ImageIcon;
  if (contentType.startsWith("video/")) return FileVideo;
  if (contentType.startsWith("audio/")) return FileAudio;
  return File;
}

export function isPreviewable(filename = "", contentType = "") {
  const ext = (filename.split(".").pop() || "").toLowerCase();
  return contentType.startsWith("image/") || contentType === "application/pdf" ||
    ["png", "jpg", "jpeg", "gif", "webp", "svg", "pdf"].includes(ext);
}

// Renewal/expiry badge meta for a document. Returns null when no date is set.
// tone: "expired" (red) | "soon" (amber, <=30d) | "ok" (subtle). label is short.
export function expiryMeta(dateStr, lang = "fr") {
  if (!dateStr) return null;
  const d = new Date(`${dateStr}T00:00:00`);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const days = Math.round((d - today) / 86400000);
  const fmt = d.toLocaleDateString(lang === "fr" ? "fr-FR" : "en-US",
    { day: "2-digit", month: "short", year: "numeric" });
  if (days < 0) return { tone: "expired", label: lang === "fr" ? "Expiré" : "Expired", date: fmt, days };
  if (days <= 30) return {
    tone: "soon",
    label: lang === "fr" ? `Expire dans ${days} j` : `Expires in ${days}d`,
    date: fmt, days,
  };
  return { tone: "ok", label: fmt, date: fmt, days };
}

// Distinct icons for auto vs manual folders (per design blueprint).
export const FOLDER_ICON = {
  entity: Building2,
  space: LayoutTemplate,
  board: Kanban,
  manual: Folder,
  root: Folder,
};
